import React from 'react';
import { useTranslation } from 'react-i18next';

import { ReactComponent as IconClipboard } from 'media/svg/clipboard.svg';
import { ReactComponent as IconPhoneInSpeechBubble } from 'media/svg/phoneInSpeechBubble.svg';
import { ReactComponent as IconThumbUpOutline } from 'media/svg/thumbUpOutline.svg';

import styles from '../Card.module.scss';

export interface TrustProps {
    customClass?: string;
}

const Trust = ({ customClass = '' }: TrustProps) => {
    const { t } = useTranslation();
    const classList = `${styles.ServiceTrust} ${customClass}`;

    return (
        <div className={classList}>
            <div>
                <div className={styles.ServiceIcon}>
                    <IconPhoneInSpeechBubble />
                </div>
                <div>
                    <div className={styles.Headline}>
                        {t('TRANS-top-service-title')}
                    </div>
                    {t('TRANS-top-service')}
                </div>
            </div>
            <div>
                <div className={styles.ServiceIcon}>
                    <IconThumbUpOutline />
                </div>
                <div>
                    <div className={styles.Headline}>
                        {t('TRANS-best-offer-title')}
                    </div>
                    {t('TRANS-best-offer')}
                </div>
            </div>
            <div>
                <div className={styles.ServiceIcon}>
                    <IconClipboard />
                </div>
                <div>
                    <div className={styles.Headline}>
                        {t('TRANS-well-prepared-title')}
                    </div>
                    {t('TRANS-well-prepared')}
                </div>
            </div>
        </div>
    );
};

export default Trust;
